import classNames from 'classnames';

import { useTimeZonedFunctions } from '/src/hooks';

export function Date({ className, date }) {
  const { formatDay, timeZone } = useTimeZonedFunctions();

  return (
    <span className={classNames(className)}>
      {formatDay(date)} ({timeZone.primary})
    </span>
  );
}
